export default __webpack_public_path__ + "static/media/hefeos_logo_03.4c56cfa7.svg";